import accountInfo from './account-info.js';
import {
	history,
	basePathname,
	push,
	pushBack,
	pushBasePathname
} from './store/history.js';
import {
	eventType
} from './config/settings.js';
import './config.js';
import './bonus-progress.js';

/* These menues are unique, and are therefore selected by id. The intention is
to open the main menues from the first page. To open sublevels of these menues
 see the specific files prefixed by 'menues_'
 for example:
 menues_account.js
 menues_global.js
 */
const accountMenuElm = document.querySelector('#js-account-menu');

const globalMenuElm = document.querySelector('#js-global-menu');
const bottomWrapperElm = document.querySelector('.js-bottom-wrapper');
// let mysettingsElm = document.querySelector('.my-account-settings');
const mysettingsElm = document.querySelector('#js-account-menu');
const notifyIsOpenClassname = 'notify--is-open';
const menuIsOpenClassname = 'menu--is-open';
const bottomWrapperLoginOpenClassname = 'log-in--open';
let prevScrollPos;
let verifyEmail;
let globalBackIsBound = false;

function addIsOpenclassScrollToTop(elm, openClassname) {
	/* add open-class, note scrollposition, scroll to top */
	elm.classList.add(openClassname);
	window.scrollTo(0, 0);
}

function makeBackgroundUnscrollable() {
	// TODO set css on pusherelement to prevent scrolling of background when menu is open
}

function makeBackgroundScrollable() {
	// TODO reset css on pusherelement to accept scrolling of background when menu is closed
}

function noteCurrentScroll() {
	prevScrollPos = {
		x: window.scrollX,
		y: window.scrollY
	};
}

function scrollToPrevious() {
	if (prevScrollPos) {
		window.scroll(prevScrollPos.x, prevScrollPos.y);
	}
}

function removeIsOpenClass(elem, openClassname) {
	if (elem) {
		elem.classList.remove(openClassname);
	}
}

if (mysettingsElm) {
	verifyEmail = mysettingsElm.querySelector('.js-verify_email');
}

accountMenuElm.querySelector('.js-menu__close .icon-close--back').addEventListener('click', pushBasePathname, false);

function close() {
	if (globalMenuElm && accountMenuElm) {
		removeIsOpenClass(globalMenuElm, menuIsOpenClassname);
		removeIsOpenClass(accountMenuElm, menuIsOpenClassname);
	}

	removeIsOpenClass(bottomWrapperElm, bottomWrapperLoginOpenClassname);
	scrollToPrevious();
}

function closeMenuesExceptGlobalMenu() {
	if (accountMenuElm) {
		removeIsOpenClass(accountMenuElm, menuIsOpenClassname);
	}
	removeIsOpenClass(bottomWrapperElm, bottomWrapperLoginOpenClassname);
	scrollToPrevious();
}

export default {
	openGlobalMenu() {
		const closeButton = document.querySelector('.js-menu__close .icon-close--back');
		closeButton.setAttribute('href', basePathname());
		/*
		if (!globalBackIsBound) {
			closeButton.addEventListener(eventType, pushBasePathname);
			globalBackIsBound = true;
		}
		*/

		noteCurrentScroll();
		// this puts odds at top of list if it exists
		if(globalMenuElm){
			const sbListItem = globalMenuElm.querySelector("li[data-product='sportsbook']");
			if (sbListItem) {
				sbListItem.parentNode.insertBefore(sbListItem, sbListItem.parentNode.firstChild);
			}
			addIsOpenclassScrollToTop(globalMenuElm, menuIsOpenClassname);
		}
	},
	openAccountMenu() {
		noteCurrentScroll();
		addIsOpenclassScrollToTop(accountMenuElm, menuIsOpenClassname);
		/* update accountInfo module*/
		accountInfo.getPlayerInfo();
		accountInfo.getPlayerBalance();
		accountInfo.getPlayerPoints();
	},
	openLoginMenu() {
		noteCurrentScroll();
		/* the login is child of bottomwrapper. Also the login functionality and some ui is handled by login.js*/
		addIsOpenclassScrollToTop(bottomWrapperElm, bottomWrapperLoginOpenClassname);
	},
	close,
	closeMenuesExceptGlobalMenu,
	openMySettings() {
		noteCurrentScroll();
		addIsOpenclassScrollToTop(mysettingsElm, menuIsOpenClassname);
	},
	openVerifyEmail() {
		noteCurrentScroll();
		addIsOpenclassScrollToTop(verifyEmail, notifyIsOpenClassname);
	},
	closeVerifyEmail() {
		removeIsOpenClass(verifyEmail, notifyIsOpenClassname);
		scrollToPrevious();
	},
	closeMySettings() {
		removeIsOpenClass(mysettingsElm, menuIsOpenClassname);
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/menues_rootview.js